function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "italy-circle-clip"
}, React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 50
})));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  fill: "#008C45",
  clipPath: "url(#italy-circle-clip)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33.333,
  y: 0,
  width: 33.334,
  height: 100,
  fill: "#F4F5F0",
  clipPath: "url(#italy-circle-clip)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 66.667,
  y: 0,
  width: 33.333,
  height: 100,
  fill: "#CD212A",
  clipPath: "url(#italy-circle-clip)"
});

var SvgItaly = function SvgItaly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgItaly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/italy.d16b8e08.svg";
export { ForwardRef as ReactComponent };